export const DateFrame = {
    TODAY: 'TODAY',
    YESTERDAY: 'YESTERDAY',
    '7DAYS': '7DAYS',
    MONTH: 'MONTH',
    LAST_MONTH: 'LAST_MONTH',
    LAST_3MONTHS: 'LAST_3MONTHS',
    LAST_6MONTHS: 'LAST_6MONTHS',
    YEAR: 'YEAR',
    CUSTOM: 'CUSTOM',
} as const;

export type DateFrame = (typeof DateFrame)[keyof typeof DateFrame];

export type TimeFrame = {
    startDate?: Date;
    endDate?: Date;
    frame: {
        timeEnum: DateFrame;
        timeLabel: string;
    };
};

export const TimePickerType = {
    SHORT: 0,
    LONG: 1,
} as const;

export type TimePickerType = (typeof TimePickerType)[keyof typeof TimePickerType];

export type TimePickerProps = {
    timeFrame: TimeFrame;
    setTimeFrame: (frame: TimeFrame) => void;
    timePickerType: TimePickerType;
    callback: (startDate?: Date, endDate?: Date) => void;
    disabled?: boolean;
    selectByMonth?: boolean;
};
